import { render, staticRenderFns } from "./ClientAddressesContainer.vue?vue&type=template&id=3204e848&scoped=true"
import script from "./ClientAddressesContainer.vue?vue&type=script&lang=js"
export * from "./ClientAddressesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204e848",
  null
  
)

export default component.exports